export interface ILOV {
  id: number;
  code: string;
  description: string;
  children?: ILOV[];
}

export const publicLOVGQL: Record<string, string> = {
  allLOV: `query RetrieveAllLOV() {
    itemCategoryLOV: itemCategoryLOV {
      id
      code
      description
      children {
        id
        code
        description
      }
    }
    itemSubCategoryLOV: itemSubCategoryLOV {
      id
      code
      description
    }
    itemQualityLOV: itemQualityLOV {
      id
      code
      description
    }
    itemStyleLOV: itemStyleLOV {
      id
      code
      description
    }
    itemBrandCategoryLOV: itemBrandCategoryLOV {
      id
      code
      description
    }
    itemSizeLOV: itemSizeLOV {
      id
      code
      description
    }
    itemMaterialLOV: itemMaterialLOV {
      id
      code
      description
    }
    membershipTypeLOV: membershipTypeLOV {
      id
      code
      description
    }
    memberSourceLOV: memberSourceLOV {
      id
      code
      description
    }
    deliveryTypeLOV: deliveryTypeLOV {
      id
      code
      description
    }
    deliveryTypeCollectStatusLOV: deliveryStatusLOV(deliveryType:"collect") {
      id
      code
      description
    }
  }`,
  itemLOV: `query RetrieveItemLOV() {
    itemCategoryLOV: itemCategoryLOV {
      id
      code
      description
      children {
        id
        code
        description
      }
    }
    itemSubCategoryLOV: itemSubCategoryLOV {
      id
      code
      description
    }
    itemQualityLOV: itemQualityLOV {
      id
      code
      description
    }
    itemStyleLOV: itemStyleLOV {
      id
      code
      description
    }
    itemBrandCategoryLOV: itemBrandCategoryLOV {
      id
      code
      description
    }
    itemSizeLOV: itemSizeLOV {
      id
      code
      description
    }
    itemMaterialLOV: itemMaterialLOV {
      id
      code
      description
    }
  }`,
  membershipTypeLOV: `query RetrieveMembershipTypeLOV() {
    membershipTypeLOV: membershipTypeLOV {
      id
      code
      description
    }
  }`,
  memberSourceLOV: `query RetrieveMemberSourceLOV() {
    memberSourceLOV: memberSourceLOV {
      id
      code
      description
    }
  }`,
  deliveryLOV: `query RetrieveDeliveryLOV() {
    deliveryTypeLOV: deliveryTypeLOV {
      id
      code
      description
    }
    deliveryTypeCollectStatusLOV: deliveryStatusLOV(deliveryType:"collect") {
      id
      code
      description
    }
  }`,
};
